module.exports = __webpack_public_path__ + "static/patrick-raftery-headshot-2018-1-small-81e733c8b86dcba36aa43aa3eb9b1bc8.jpg";